import { useContext, useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import { CustomToast } from '../toast/CustomToast';
import { Text, Stack, Flex, Box, Avatar } from '@chakra-ui/react';
import BrandButton from '../brandButton/BrandButton';
import { mutateFunction } from '../../libs/apis';
import moment from 'moment';
import { UserContext } from '../../context/UserContext';
import AutoResizeTextarea from './AutoResizeTextArea';
import { useLocation } from 'react-router-dom';
import { BsSend } from 'react-icons/bs';

const CreateComment = ({
  post,
  onClose = () => {},
  onSuccess = () => {},
  showCloseButton = true,
  showReplyButton = true,
  showAltReplyButton = false,
  showPost = true,
  refetchPost = () => {},
  replyTo = null,
  isDisabled = false,
}) => {
  const { mutate, isLoading } = useMutation(mutateFunction);
  const { addToast } = CustomToast();
  const [postMessage, setPostMessage] = useState('');
  const { userInformation = {} } = useContext(UserContext);
  const [isPublic, setIsPublic] = useState('');
  const location = useLocation();

  const formSubmit = async (e) => {
    e.preventDefault();
    if (isPublic || isLoading) return;

    if (!postMessage.trim()) {
      addToast({ message: 'Please add a comment' }, 'warning');
      return;
    }

    mutate(
      {
        key: 'comment/create',
        method: 'post',
        data: {
          text: `${postMessage.trim()}`,
          post_id: post.id,
          reply_to: replyTo,
        },
      },
      {
        onSuccess(res) {
          addToast(res);
          onClose(true);
          setPostMessage('');
          refetchPost();
          onSuccess();
          // onSuccess({
          //   ...res.data.comment,
          //   user: {
          //     first_name: userInformation?.firstName,
          //     last_name: userInformation?.lastName,
          //     profile_image: userInformation?.profile_image,
          //   },
          // });
        },
        onError(e) {
          addToast({ message: 'Comment was not created' }, 'error');
        },
      },
    );
  };

  useEffect(() => {
    if (location.pathname.includes('public')) {
      setIsPublic(true);
    } else {
      setIsPublic(false);
    }
  }, [location]);

  return (
    <Flex flexDirection="column">
      <Stack spacing={6}>
        {showPost ? (
          <Flex className="items-start w-full mb-5 gap-2" justify={'center'}>
            <Box>
              <Avatar
                src={post.user.profile_image ?? null}
                name={`${post.user.first_name} ${post.user.last_name}`}
                size={'md'}
              />
            </Box>
            <Box className="flex flex-col w-full">
              <Box className="flex items-center text-sm gap-2">
                <Text className="font-bold text-[#134a70]">{`${post.user.first_name} ${post.user.last_name}`}</Text>
                <Text className="text-xs text-gray-600">
                  {moment(post.createdAt).fromNow()}
                </Text>
              </Box>
              <Text
                className="preview_message text-sm w-full"
                color="#000"
                textOverflow="ellipsis"
              >
                {post?.text.split('\n\n').map((text) => (
                  <span>
                    {text}
                    <br />
                  </span>
                ))}
              </Text>
            </Box>
          </Flex>
        ) : null}
      </Stack>
      <Box mt={'20px'} className="flex items-start gap-2">
        <Box>
          <Avatar
            src={userInformation?.profile_image}
            name={`${userInformation?.firstName} ${userInformation?.lastName}`}
            size={'sm'}
          />
        </Box>
        <Flex
          borderWidth="1px"
          // borderColor="brand.primary"
          alignItems="center"
          className="w-full rounded-3xl bg-gray-200"
        >
          <form className="w-full" onSubmit={formSubmit}>
            <AutoResizeTextarea
              focusBorderColor="#"
              borderWidth="0px"
              background="transparent"
              variant="outline"
              isRequired={true}
              name="postMessage"
              value={postMessage}
              onChange={(e) => setPostMessage(e.target.value)}
              placeholder="Leave a comment...."
              type="postMessage"
              w={'full'}
              maxLength={150}
            />
          </form>
        </Flex>
        {
          showAltReplyButton && !showReplyButton ?(
            <Box className={`cursor-pointer p-2 rounded-full ${postMessage.trim() && !isLoading? 'bg-[#134a70] text-white' : 'bg-gray-200 text-gray-400'}`} onClick={formSubmit}>
              <BsSend />
            </Box>
          ) : null
        }
      </Box>
      <Box className="flex justify-end my-1">
        <Text
          className={`text-xs font-semibold ${postMessage.length < 150 ? 'text-gray-600' : 'text-red-800'}`}
        >
          {postMessage.length} / {150} characters
        </Text>
      </Box>
      {
        showReplyButton  || showCloseButton ? (
          <Flex
        gap={10}
        className={`mt-6 ml-10 items-center ${showCloseButton ? 'justify-between' : 'justify-end'}`}
      >
        {showCloseButton ? (
          <BrandButton text="Close" onClick={onClose} />
        ) : null}
        {
          showReplyButton ? (
          <BrandButton
            isLoading={isLoading}
            text={`Reply`}
            onClick={formSubmit}
            type="submit"
            variant="md"
            bgColor="brand.primary"
            color="#fff"
            fontSize="14px"
            borderRadius={4}
            px={4}
            isDisabled={isDisabled}
            _hover={{ background: 'brand.primary' }}
          />) : null}
      </Flex>
        ) : null
      }
    </Flex>
  );
};

export default CreateComment;
